import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const Experience = ({ experiences, root }) => {
	const navigate = useNavigate()
	const scrolToTop = () =>{
		navigate(`/experiences`)
		window.scrollTo({top: 0, behavior: "smooth"})
	}
	return (
		<>
			{root === 'Not root' && (
				<h2 className="w-11/12 mx-auto mb-10 text-center text-2xl xs:text-3xl sm:text-5xl font-bold mt-28 scroll-mt-36">
					Experience
				</h2>
			)}
			{experiences.map(
				({ role, company, workType, startEnd, descriptions, id }) => (
					<motion.div
						key={id}
						initial={{ opacity: 0 }}
						whileInView={{
							opacity: 1,
							transition: { duration: 1.5, ease: 'easeOut' },
						}}
						viewport={{ once: true }}
						className="w-11/12 h-fit mx-auto mb-10 px-5 xs:px-8 py-8 flex flex-col md:flex-row justify-center md:justify-between gap-4 rounded-xl bg-light-naive shadow-[0px_0px_7px_hsl(204,23.8%,95.9%,.7)]"
					>
						<div className="w-full md:w-3/6 mx-auto flex flex-col gap-1">
							<p className=" text-sky-blue font-bold text-lg">{role}</p>
							<p className=" text-gray font-medium">{company}</p>
							<p className="font-light">{startEnd}</p>
							<p className="font-light">{workType}</p>
						</div>
						<ul className="w-full md:w-3/6 flex flex-col justify-start gap-1 font-light list-[square]">
							{descriptions.map((description, index) => (
								<li key={index}>{description}</li>
							))}
						</ul>
					</motion.div>
				)
			)}
			{root === 'root' && (
				<div onClick={scrolToTop}
					className="w-11/12 mx-auto mb-20 flex flex-col justify-center items-center no-underline"
				>
					<motion.button
						whileHover={{
							scale: 1.02,
							backgroundColor: 'rgb(184, 46, 46)',
							textShadow: '0px 0px 8px rgb(255, 255, 255)',
							boxShadow: '0px 0px 8px rgb(255, 255, 255)',
							transition: { duration: 0.3, repeat: Infinity },
						}}
						className="w-full xs:w-[380px] h-[40px] xs:h-[45px] flex flex-col justify-center items-center rounded-lg bg-light-red text-lg xs:text-xl"
					>
						View All...
					</motion.button>
				</div>
			)}
		</>
	);
};

export default Experience;
